// extracted by mini-css-extract-plugin
module.exports = {"storiesWrapper":"StoriesWrapper_storiesWrapper__tW4Ea"};